import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, DatePicker, Divider, Drawer, Form, Select, Space } from "antd";
import { Input } from "antd/lib";
import React, { FC } from "react";
import { CalcMethod } from "../../../Services/FixedAssetsServiceNew";
import { IFALocation } from "../../../Services/AssetLocationService";
import { IIdNameModel } from "../../../Services/ItemsService";
import { checkCategoryCheckboxMaintain } from "../Items/AddAssetItems";
import { dayjs } from "../../../../Utilities/dayjs";
import { useState, useEffect } from "react";
import AddAssetLocationModal from "../Location/AddAssetLocationModal";
import AddEmpModel from "../../Organisations/AddEmpModel";
export interface FieldConfig {
  name: string;
  label: string;
  type: "input" | "select" | "date";
  maintainKey: string;
  options?: { value: string; label: string }[];
  props?: any;
}

const AddAssetOtherDetails: FC<{
  open: boolean;
  isLocked: boolean;
  onCancel: any;
  itemName: string;
  itemIndex: number;
  assetsLocationList: IFALocation[];
  employeeList: IIdNameModel[];
  assetId: string;
  assetItemList: any[];
  saveAssetItemIndexData: any;
  details?: any;
  setTrigger?: any;
  updateId?: string;
  voucherDate?: string;
  setAssetLocationList: React.Dispatch<React.SetStateAction<IFALocation[]>>;
  setEmployeeList: React.Dispatch<React.SetStateAction<IIdNameModel[]>>;
}> = (props) => {
  const [form] = Form.useForm();
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  const [modelLoading, setModelLoading] = React.useState<boolean>(false);
  const [trigger, setTrigger] = React.useState<number>(0);
  const [modelOpen, setModelOpen] = useState({ type: "", open: false });
  const [addAssLocation, setAddAssLocation] = useState<IFALocation>({
    locationName: "",
    id: "",
  });
  const [addEmployee, setAddEmployee] = useState<IIdNameModel>({
    id: "",
    name: "",
  });
  const [empModel, setEmpModel] = useState({ open: false, id: "" });

  React.useEffect(() => {
    // debugger
    setTrigger(0);
    if (props.assetId) {
      const data = props.assetItemList.find((x: any) => x.id === props.assetId);
      form.setFieldsValue({
        ...props.details,
        warranty: dayjs(
          dayjs(props.details?.warranty)?.format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ),
        depreciationStartDate:
          dayjs(props.voucherDate) ??
          dayjs(
            dayjs(props.details?.depreciationStartDate)?.format("DD/MM/YYYY"),
            "DD/MM/YYYY"
          ),
        isDepreciable: data?.isDepreciable,

        maintainLocation: data?.maintainLocation,
        maintainModel: data?.maintainModel,
        maintainIdentityMark: data?.maintainIdentityMark,
        maintainWarranty: data?.maintainWarranty,
        maintainVariant: data?.maintainVariant,
        maintainOption: data?.maintainOption,
        maintainEmployeeAssign: data?.maintainEmployeeAssign,

        variant: data?.assetVariant,
        option: data?.assetOption,
        model: data?.assetModel,
        depMethod: data?.depMethod,
        lifeCycleDuration: data?.lifeCycleDuration,
        depRate: data?.depRate,
      });
    }
    setTrigger((x) => x + 1);
  }, [props.details, form, props.assetItemList, props.assetId]);

  //
  useEffect(() => {
    if (addAssLocation.id.length > 0) {
      props.setAssetLocationList((pre: any) => {
        let newData = [...pre, addAssLocation];
        return newData;
      });

      form.setFieldValue("location", addAssLocation.id);
    }
  }, [addAssLocation.locationName.length > 0]);

  //
  useEffect(() => {
    if (addEmployee.id.length > 0) {
      props.setEmployeeList((pre: IIdNameModel[]) => {
        let newData = [...pre, addEmployee];
        return newData;
      });
      form.setFieldValue("empId", addEmployee.id);
    }
  }, [addEmployee.id.length > 0]);

  // Post data
  const postData = () => {
    form.validateFields().then(async (value) => {
      const postData = {
        index: props.itemIndex,
        location: value?.location,
        warranty: value?.warranty
          ? dayjs(value?.warranty).toISOString()
          : undefined,
        empId: value?.empId,
        depreciationStartDate: value?.depreciationStartDate
          ? dayjs(value?.depreciationStartDate).toISOString()
          : undefined,
        identityCode: value?.identityCode,
        residualValue: value?.residualValue,
      };
      props.saveAssetItemIndexData(postData);
      props.onCancel();
      console.log(value);
    });
    setSaveButtonLoading(true);
  };
  // inside AddAssetOtherDetails.tsx
  const fields: FieldConfig[] = [
    {
      name: "location",
      label: "Location",
      type: "select",
      maintainKey: "maintainLocation",
      options: props.assetsLocationList?.map((l) => ({
        value: l.id,
        label: l.locationName,
      })),
    },
    {
      name: "identityCode",
      label: "Identity Code",
      type: "input",
      maintainKey: "maintainIdentityMark",
      props: { placeholder: "Identity Code", disabled: props.isLocked },
    },
    {
      name: "warranty",
      label: "Warranty Date",
      type: "date",
      maintainKey: "maintainWarranty",
      props: { placeholder: "Warranty Date", disabled: props.isLocked },
    },
    {
      name: "empId",
      label: "Employee Assign",
      type: "select",
      maintainKey: "maintainEmployeeAssign",
      options: props.employeeList?.map((e) => ({ value: e.id, label: e.name })),
    },
    {
      name: "model",
      label: "Model",
      type: "input",
      maintainKey: "maintainModel",
      props: { disabled: true, variant: "borderless" },
    },
    {
      name: "variant",
      label: "Variant",
      type: "input",
      maintainKey: "maintainVariant",
      props: { disabled: true, variant: "borderless" },
    },
    {
      name: "option",
      label: "Option",
      type: "input",
      maintainKey: "maintainOption",
      props: { disabled: true, variant: "borderless" },
    },
  ];

  const renderField = (field: FieldConfig) => {
    const maintain = form.getFieldValue(field.maintainKey);
    const value = form.getFieldValue(field.name);

    // aapke checkCategoryCheckboxMaintain logic ko replace karega:
    if (!checkCategoryCheckboxMaintain(maintain, value, props.updateId))
      return null;

    if (field.type === "input") {
      return (
        <Form.Item
          name={field.name}
          label={field.label}
          wrapperCol={{ span: 24 }}
          className="input-item"
        >
          <Input {...field.props} style={{ width: "100%" }} />
        </Form.Item>
      );
    }

    if (field.type === "select") {
      return (
        <Form.Item
          name={field.name}
          label={field.label}
          wrapperCol={{ span: 24 }}
          className="input-item"
        >
          <Select
            style={{ width: "100%" }}
            allowClear
            showSearch
            placeholder={field.label}
            options={field.options}
            {...field.props}
            dropdownRender={(itemsOption) => (
              <>
                {itemsOption}
                {field.name === "location" ? (
                  <>
                    <Divider
                      style={{
                        margin: "5px 0px",
                      }}
                    />
                    <Button
                      style={{
                        width: "100%",
                      }}
                      icon={<PlusOutlined />}
                      type="link"
                      onClick={() =>
                        setModelOpen({ type: "AddAssetLocation", open: true })
                      }
                    >
                      Add Location
                    </Button>
                  </>
                ) : (
                  <>
                    <>
                      <Divider
                        style={{
                          margin: "5px 0px",
                        }}
                      />
                      <Button
                        style={{
                          width: "100%",
                        }}
                        icon={<PlusOutlined />}
                        type="link"
                        onClick={() => setEmpModel({ open: true, id: "" })}
                      >
                        Add Employee
                      </Button>
                    </>
                  </>
                )}
              </>
            )}
          />
        </Form.Item>
      );
    }

    if (field.type === "date") {
      return (
        <Form.Item
          name={field.name}
          label={field.label}
          wrapperCol={{ span: 24 }}
          className="input-item"
        >
          <DatePicker
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
            {...field.props}
            disabledDate={(current) =>
              current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
            }
          />
        </Form.Item>
      );
    }

    return null;
  };

  const checkAllCategory = fields.every(
    (f) =>
      !checkCategoryCheckboxMaintain(
        form.getFieldValue(f.maintainKey),
        form.getFieldValue(f.name),
        props.updateId
      )
  );

  return (
    <div>
      <Drawer
        maskClosable={false}
        open={props.open}
        title={`Item - ${props.itemName}`}
        width={550}
        // onCancel={() => props.onCancel()}
        // closable={props.onCancel}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.onCancel()} />
          </Space>
        }
        footer={
          <div style={{ marginTop: "0px" }}>
            <Space
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: 20,
              }}
            >
              <Button
                onClick={() => {
                  form.resetFields();
                  props.onCancel();
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => postData()}
                loading={saveButtonLoading}
                className="modelSaveButtonMargin"
              >
                {props?.updateId ? "Update" : "Save"}
              </Button>
            </Space>
          </div>
        }
        className="ledgerdrawerstyle"
      >
        {/* <Divider className="ca-model-css" /> */}
        {/* <Spin indicator={antIcon} spinning={modelLoading}> */}
        <Form
          form={form}
          name="item"
          autoCapitalize="false"
          requiredMark={true}
          colon={false}
          labelAlign="left"
          style={{ margin: "0px", padding: "0px" }}
          labelCol={{ xs: 24, sm: 9 }}
          wrapperCol={{ xs: 24, sm: 15 }}
          labelWrap={true}
        >
          {fields.map((f) => renderField(f))}

          {checkAllCategory && !form.getFieldValue("isDepreciable") && (
            <Divider>No Other Details</Divider>
          )}

          {/*  Depreciable Asset */}
          {form.getFieldValue("isDepreciable") && (
            <>
              <Divider
                orientation="left"
                orientationMargin="0"
                style={{
                  marginTop: checkAllCategory ? "0px" : "14px",
                  marginBottom: "14px",
                }}
              >
                <p style={{ fontWeight: 500, fontSize: "14px" }}>
                  Depreciable Asset
                </p>
              </Divider>

              <Form.Item
                className="input-item"
                wrapperCol={{
                  span: 24,
                }}
                name="depreciationStartDate"
                label="Depreciation Start Date"
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                  }
                />
              </Form.Item>

              {/* Depreciation Method */}
              <Form.Item
                className="input-item"
                wrapperCol={{
                  span: 24,
                }}
                name="depMethod"
                label="Depreciation Method"
              >
                <Select
                  style={{ marginBottom: "3px" }}
                  disabled={true}
                  variant="borderless"
                  //defaultValue={CalcMethod.WrittenDownValue}
                  options={[
                    {
                      value: CalcMethod.StraightLine,
                      label: "Straight Line Method",
                    },
                    {
                      value: CalcMethod.WrittenDownValue,
                      label: "Written Down Method",
                    },
                  ]}
                />
              </Form.Item>

              {/* Asset Life in year */}
              <Form.Item
                className="input-item"
                wrapperCol={{
                  span: 24,
                }}
                name="lifeCycleDuration"
                label="Asset Life in year"
              >
                <Input
                  disabled={true}
                  variant="borderless"
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>

              {/* Depreciation Rate
               */}
              <Form.Item
                className="input-item"
                wrapperCol={{
                  span: 24,
                }}
                name="depRate"
                label="Depreciation Rate"
              >
                <Input
                  disabled={true}
                  variant="borderless"
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>
              {/* Residual Value */}
              {form.getFieldValue("depMethod") === CalcMethod.StraightLine && (
                <Form.Item
                  label="Residual Value"
                  className="input-item"
                  wrapperCol={{
                    span: 24,
                  }}
                  name="residualValue"
                >
                  <Input
                    // disabled={true}
                    // variant="borderless"
                    style={{
                      width: "100%",
                    }}
                    placeholder="Residual Value"
                  />
                </Form.Item>
              )}
            </>
          )}
        </Form>
        {/* </Spin> */}
      </Drawer>
      {modelOpen.type === "AddAssetLocation" && (
        <AddAssetLocationModal
          isModelOpen={modelOpen.open}
          onCancel={() => setModelOpen({ type: "", open: false })}
          placement="left"
          setAddAssLocation={setAddAssLocation}
        />
      )}
      {empModel.open === true && (
        <AddEmpModel
          isModalOpen={empModel.open}
          setIsModalOpen={setEmpModel}
          setAddedEmployee={setAddEmployee}
          placement="left"
        />
      )}
    </div>
  );
};

export default AddAssetOtherDetails;
